import type { LogMessageType } from './types/TaskReporterTaskStatus.js';

/** Prefix character for each task status and console log method */
export const prefixCharacters: Record<LogMessageType, string> = {
  running: '-',
  warn: '!',
  abort: '?',
  complete: '✓',
  fail: '✗',
  error: '✗',
  debug: '-',
  info: '-',
  log: '-',
  pending: '-',
  skip: '-',
};
